import React from 'react';
import PropTypes from 'prop-types';

import {DownloadTemplate, SidePanel, UploadDocument} from 'front-onceforall-core';

const TEMPLATE_STEP_INDEX = 1;
const UPLOAD_STEP_INDEX = 2;

export function DownloadAndUploadDocumentPanel(props) {
  const [currentStep, setCurrentStep] = React.useState(TEMPLATE_STEP_INDEX);

  function handleNextStep() {
    setCurrentStep(UPLOAD_STEP_INDEX);
  }

  function handlePreviousStep() {
    setCurrentStep(TEMPLATE_STEP_INDEX);
  }

  const getStep = () => {
    if (currentStep === TEMPLATE_STEP_INDEX) {
      return (<DownloadTemplate
        document={props.document}
        onClose={props.onClose}
        onHandleSubmit={handleNextStep}
        pathDocumentTemplate={props.documentTemplate}
      />);
    }

    return (<UploadDocument
      document={props.document}
      documentEquivalences={[props.document.type]}
      onCancel={handlePreviousStep}
      onHandleSubmitFile={props.onSubmit}
      submitted={props.submitting}
      extensions={'.pdf'}
      showMetadataForm={false}
    />);
  };

  return (
    <SidePanel
      big={true}
      onClose={props.onClose}
    >
      {getStep()}
    </SidePanel>
  );
}

DownloadAndUploadDocumentPanel.propTypes = {
  documentTemplate: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default DownloadAndUploadDocumentPanel;
